export default "__VITE_ASSET__CQDhoTPY__"